export default {
  API: {
    Base: 'https://apiapplicationtest.businesstrainingshpwc.com'
    // Base: 'http://localhost:51251/'
  },
  PUBLIC_URL: 'https://youplusapplicationtest.businesstrainingshpwc.com'
}
